export default __webpack_public_path__ + "static/media/world.eddc8d65.svg";